const CallTracker = settings => {
	const module = {
		settings,
		init: function() {
			if (Object.keys(settings).length === 0 ) {
				return;
			}

			this.updatePhones();
		},
		getCallTrackingPhone: function() {
			const sourceCookie = TRMK_SOURCE_TRACKER.getSourceData();
			const {triggers} = this.settings;
			let targetPhone = '';

			// Loop through triggers
			Object.keys(triggers).forEach(trigger => {
				if (sourceCookie.hasOwnProperty(trigger)) {
					Object.keys(triggers[trigger]).forEach(key => {
						if (key === sourceCookie[trigger]) {
							targetPhone = triggers[trigger][key];
						}
					});
				}
			});

			return targetPhone;
		},
		updatePhones: function() {
			const phone = this.getCallTrackingPhone();
			const { swap } = this.settings;

			if (phone === '') {
				return;
			}

			$(`a:contains(${swap})`).each((i, el) => {
				const html = $(el).html();
				const href = $(el).attr('href');
				const swapDigitsOnly = swap.replace(/\D/g, '');
				const newHref = href.replace(new RegExp(swapDigitsOnly, 'g'), phone.replace(/\D/g, ''));
				const newHtml = html.replace(new RegExp(swap, 'g'), phone);
				$(el).attr('href', newHref).html(newHtml);
			});
		}
	}

	// Self init
	module.init();

	return module;
}

/**
 * Jquery document ready.
 * Initialize CallTracker library.
 */
$(document).on('trmk:source-tracker-initialized', () => {
	const ct = new CallTracker(window.TRMK_CALL_TRACKING_VARS || {});
});
